import { Button, Group, Input } from "@chakra-ui/react";
import {
  ChangeEvent,
  KeyboardEvent,
  useCallback,
  useRef,
  useState,
} from "react";

export interface CreateCardProps {
  onCreate?: (name: string) => void;
}

export function CreateCard({ onCreate }: CreateCardProps) {
  const [value, setValue] = useState("");
  const onBlurTimerRef = useRef<number | null>(null);
  const inputRef = useRef<HTMLInputElement | null>(null);

  const onBlur = useCallback(() => {
    onBlurTimerRef.current = setTimeout(() => {
      setValue("");
    }, 100);
  }, []);

  const onChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  }, []);

  const onClick = useCallback(() => {
    if (onBlurTimerRef.current) {
      clearTimeout(onBlurTimerRef.current);
      onBlurTimerRef.current = null;
    }
    if (value.trim() === "") {
      return;
    }

    onCreate?.(value);
    setValue("");
    inputRef.current?.focus();
  }, [onCreate, value]);

  const onKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === "Enter") {
        onClick();
      }
    },
    [onClick],
  );

  return (
    <Group attached w="full" maxW="sm">
      <Input
        ref={inputRef}
        value={value}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        onChange={onChange}
        flex="1"
        placeholder="Enter name of a new todo"
      />
      <Button
        disabled={!value}
        bg="bg.subtle"
        variant="outline"
        onClick={onClick}
      >
        Create
      </Button>
    </Group>
  );
}
